import React, {useState, Fragment, useEffect} from "react";
import {connect} from "react-redux";
import {translate} from '@elements/translations';
import {getInvoicesByItemId} from "../actions/actions";
import {FETCHING_STATE, formatDate, noop} from "../../shared/utils";
import {getInvoicesByIds, getInvoicesFetchingState, getNotesByIds, getOrdersById} from "../reducer/rootReducer";
import Loading from "../../shared/components/Loading";

const TableRowItem = ({id, invoices = {}, notes = {}, orders = {}, orderDate = null, fetchingState, onGetInvoices = noop}) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (Object.keys(invoices).length === 0 || Object.keys(notes).length === 0) {
            onGetInvoices(id)
        }
    }, [id]);

    useEffect(() => {
        if (fetchingState === FETCHING_STATE.PENDING && (Object.keys(invoices).length === 0 && Object.keys(notes).length === 0)) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }
    })

    return (
        <Fragment>
            {isLoading ? (
                <Loading className={'loading-overlay--content'} headline={translate('loading-spinner.label')} />
            ): (
                <table className="table table-with-border mb-0">
                    <thead>
                    <tr>
                        <th>{translate('order-archive.invoices-type')}</th>
                        <th>{translate('order-archive.invoices-number')}</th>
                        <th>{translate('order-archive.invoices-date')}</th>
                        <th>{translate('order-archive.invoices-amount')}</th>
                        <th>{translate('order-archive.invoices-download')}</th>
                    </tr>
                    </thead>
                    <tbody>
                    {Object.values(invoices).map((item) => (
                        <tr key={item.id}>
                            <td>{item.type}</td>
                            <td>{item.number}</td>
                            <td>{formatDate(item.date, _config.lang)}</td>
                            <td><span dangerouslySetInnerHTML={{__html: item.amount}}></span></td>
                            <td>
                                {item.link ? (
                                    <a href={item.link.href} target={'_blank'} className={'btn btn-link btn-sm p-0'}>
                                        {item.link.label}
                                    </a>
                                ) : null
                                }
                            </td>
                        </tr>
                    ))}
                    {Object.values(notes).map((item) => (
                        <tr key={item.id}>
                            <td>{item.type}</td>
                            <td>{item.number}</td>
                            <td>{formatDate(item.date, _config.lang)}</td>
                            <td>{item.amount} {item.currency}</td>
                            <td>
                                {item.link ? (
                                    <a href={item.link.href} target={'_blank'} className={'btn btn-link btn-sm p-0'}>
                                        {item.link.label}
                                    </a>
                                ) : null
                                }
                            </td>
                        </tr>
                    ))}
                    {Object.values(orders).map((item) => (
                        <tr key={item.id}>
                            <td>{item.type}</td>
                            <td>{item.number}</td>
                            <td>{formatDate(orderDate, _config.lang)}</td>
                            <td>{item.amount} {item.currency}</td>
                            <td>
                                {item.link ? (
                                    <a href={item.link.href} target={'_blank'} className={'btn btn-link btn-sm p-0'}>
                                        {item.link.label}
                                    </a>
                                ) : null
                                }
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </Fragment>
    );
};


const mapStateToProps = (state, props) => {
    return {
        fetchingState: getInvoicesFetchingState(state),
        id: props.id,
        invoices: getInvoicesByIds(state, props.invoices),
        notes: getNotesByIds(state, props.notes),
        orders: getOrdersById(state, props.orders),
        orderDate: props.orderDate
    }
};

export const mapDispatchToProps = (dispatch) => {
    return {
        onGetInvoices: (id) => dispatch(getInvoicesByItemId(id))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(TableRowItem)